const modul = {
	namespaced: true,

	state: {

		bortbokadeVisas: true,	// = initialt defaultvärde

		rullningsbaraElement: [ 	// = initiala defaultvärden
			{ id:'re1', scrollTop: 0 }
		]
	},

	mutations: {

		setBortbokadeVisas(state, nyttVarde)
		{
			// `state` is the local module state
			state.bortbokadeVisas = nyttVarde;
		}

		// rullningsbaraElement muteras via en "root mutation" som används av flera modules/namespaces:
	}

	//actions: { ... },

	//getters: { ... }
};

export { modul as ssoStatestoreForteckning };
